export const dop_policy_framework = [
  {
    id: 1,
    name: 'Framework for Managing Programme Performance Information',
    summary: 'shortsummary/Framework for Managing Programme Performance Information.html',
    link: 'Framework for Managing Programme Performance Information.pdf',
    audio_en: 'audio/en/Framework for Managing Programme Performance Information_en.mp3',
    audio_af: 'audio/af/Framework for Managing Programme Performance Information_af.mp3',
    audio_xh: 'audio/xh/Framework for Managing Programme Performance Information_xh.mp3'
  },
  {
    id: 2,
    name: 'greenpapernational-strategic-planning0',
    summary: 'shortsummary/greenpapernational-strategic-planning0.html',
    link: 'greenpapernational-strategic-planning0.pdf',
    audio_en: 'audio/en/greenpapernational-strategic-planning0_en.mp3',
    audio_af: 'audio/af/greenpapernational-strategic-planning0_af.mp3',
    audio_xh: 'audio/xh/greenpapernational-strategic-planning0_xh.mp3'
  },
 {
    id: 3,
    name: 'national_policy_framework',
    summary: 'shortsummary/national_policy_framework.html',
    link: 'national_policy_framework.pdf',
    audio_en: 'audio/en/national_policy_framework_en.mp3',
    audio_af: 'audio/af/national_policy_framework_af.mp3',
    audio_xh: 'audio/xh/national_policy_framework_xh.mp3'
  }

];